import { useState, useRef, useEffect } from "react";
import { Icon } from '@iconify/react';

const ExpandableText = ({ description }) => {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (expanded) {
      contentRef.current.style.maxHeight = contentRef.current.scrollHeight + "px";
      contentRef.current.style.opacity = "1";
    } else {
      contentRef.current.style.maxHeight = "0px";
      contentRef.current.style.opacity = "0";
    }
  }, [expanded]);

  return (
    <div className="col-12">
      <div className="ex-right">
        <p>{description[0]}</p>

        {(!expanded) && description.length > 1 && (
          <span className="read-more" onClick={() => setExpanded(true)}>
            Read More <Icon icon="bi:arrow-down" />
          </span>
        )}

        <div
          ref={contentRef}
          className={`expand-content ${expanded ? "show" : ""}`}
        >
          {description.slice(1).map((descp_item, index) => (
            <p key={index}>{descp_item}</p>
          ))}
          <span className="read-less" onClick={() => setExpanded(false)}>
            Read Less <Icon icon="bi:arrow-up" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ExpandableText;